export default __webpack_public_path__ + "static/media/delete_ms_from_agenda.2248cae4.svg";